import { hbs } from 'ember-cli-htmlbars';
export default hbs("<NwReportsPage @url={{this.model}} />")